module.exports = __webpack_public_path__ + "img/Vultr.145a5af4.png";